import React from 'react'
import { LoginAccessGuard, AccessControlGuard } from '@guards'

interface PropsType {
	to?: string
	isShouldLoginPage?: boolean
	children: JSX.Element
}

export const AccessGuard = (props: PropsType) => {
	return (
		<LoginAccessGuard>
			<AccessControlGuard>{props.children}</AccessControlGuard>
		</LoginAccessGuard>
	)
}
